const html = document.documentElement;
const canvas = document.getElementById("hero-lightpass");
const section = document.querySelector("#sec_social-scrub");
const context = canvas.getContext("2d");
const text = document.querySelector("#animation-text");
const container = canvas.parentElement;




const frameCount = 58;
const currentFrame = index => (
    `https://cdn.shopify.com/s/files/1/0092/8137/2222/files/lq-reveal${index.toString().padStart(3, '0')}.jpg`
)


const preloadImages = () => {
    for (let i = 1; i < frameCount; i++) {
        const img = new Image();
        img.src = currentFrame(i);
    }
};

const img = new Image()
img.src = currentFrame(1);
canvas.width = canvas.parentElement.offsetWidth * 1.5;
canvas.height = canvas.parentElement.offsetWidth * 1.5;
img.onload = function () {
    context.drawImage(img, 0, 0, canvas.width, canvas.height);
}


window.addEventListener('resize', resizeCanvas, false);
function resizeCanvas() {
    canvas.width = canvas.parentElement.offsetWidth * 1.5;
    canvas.height = canvas.parentElement.offsetWidth * 1.5;
    updateImage();
}

const updateImage = index => {
    img.src = currentFrame(index);
    context.drawImage(img, 0, 0, canvas.width, canvas.height);
}
// Scroll Buffer if desktop
const addBuffer = () => {
    if (window.innerWidth > 990) {
        return 400;
    } else {
        return 0;
    }
}


window.addEventListener('scroll', () => {
    let buffer = addBuffer();
    const scrollTop = html.scrollTop;
    const sectionTop = section.offsetTop;
    const sectionHeight = section.offsetHeight;
    let fired = false;
    let scrollPercent = (scrollTop - sectionTop) / (sectionHeight - window.innerHeight - buffer);
    scrollPercent = Math.max(scrollPercent, 0);
    scrollPercent = Math.min(scrollPercent, 1);

    if (scrollPercent >= 0.8 && !fired) {
        container.classList.remove("dreambox-animation");
        text.classList.remove("lg:invisible");
        fired = true;
    }

    let frameIndex = Math.min(
        frameCount - 1,
        Math.ceil(frameCount - (scrollPercent * (frameCount - 1)))
    );

    requestAnimationFrame(() => updateImage(frameIndex - 1))
});

preloadImages()